import './billing.css';
import { Component, h, state, css, page, signal, Fragment } from 'pylevate-runtime';
import { getMe } from '../api.js';
import { Nav } from '../components/nav.js';
import { BillingPage } from '../ui/billing.js';
export class Billing extends Component {
  constructor(...args) {
    super(...args);
    this._email = signal('');
    this._portal = signal('');
    this._ready = signal(false);
  }
  get email() { return this._email.value; }
  set email(v) { this._email.value = v; }
  get portal() { return this._portal.value; }
  set portal(v) { this._portal.value = v; }
  get ready() { return this._ready.value; }
  set ready(v) { this._ready.value = v; }
  async componentDidMount() {
    let me = await getMe();
    if (!__truthy(me['signed_in'])) {
      window.location.href = '/api/auth/login?next=' + encodeURIComponent(location.pathname + location.search);
      return;
    }
    this._email.value = me['account']['email'];
    this._portal.value = (me['portal_url'] ?? undefined) || '';
    this._ready.value = true;
  }
  render(props, state, context) {
    const children = props && props.children;
    return h('div', {className: 'page-e9bf9f'}, h(Fragment, null, h(Nav, {email: this._email.value}), (this._ready.value ? h(BillingPage, {portal: this._portal.value}) : null)));
  }
}
Billing = page({title: 'Credit — eutonomous', route: '/billing'})(Billing);
